import React from 'react'
import { Route, Switch,  Router } from 'react-router-dom'
import history from '../utility/history'
import { UserAccessProvider } from './UserAccessProvider'
import TierRoute from './TierRoute'

import Home from '../page/home'
import session from '../model/session'
import Game from '../page/game'
import Smiley from '../page/test/smiley'
import SignIn from '../page/signin'
import Register from '../component/game/user_interface/registration'
import ForgotPassword from '../component/game/user_interface/forgotPassword'
import PasswordReset from '../page/passwordReset'
import Error from '../page/error'
import JamBuilder from '../component/game/user_interface/jamBuilder'
import DeckBuilder from '../../src/component/deckbuilder/deckBuilderMain'
import frontPageOld from '../component/game/user_interface/frontPageOld'
import  Dashboard from '../component/game/user_interface/dashboard'
import EventPage from '../page/event/eventpage'
import EventPage2 from '../page/event/eventpage2'
import EventSetting from '../page/event/eventsetting'
import DndPage from '../page/event/dndpage'
import frontPage from '../component/game/user_interface/frontPage'
import PasswordGate from '../component/PasswordGate'
import TermsOfUse from '../component/game/user_interface/termsOfUse'

// import Topic from '../page/topic'
// import Jam from '../page/jam'
// import Prejam from '../page/prejam'
// import Project from '../page/project'
// import ProjectList from '../page/projectList'
// import JamList from '../page/jamList'
// import Profile from '../page/profile'
// import Chat from '../page/test/chat'
// import TestCanvas from '../page/test/canvas'
// import PreGame from '../page/pregame'
// import Playground from '../page/test/playground'

const Routing = () => {
  //console.log(process.env.VERSION)
  return(
    <Router history={history}>
      <UserAccessProvider>
        <Switch>
          <Route exact path="/test/smiley" component={Smiley}/>
          <Route exact path="/game/:gid" component={Game}/>
          {/* Building/editing a template requires the create_template capability (tier 5 — Jam Builder) */}
          <TierRoute exact path="/jambuilder/:jbid" capability="create_template" component={JamBuilder}/>
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/auth/reset/:token" component={PasswordReset}/>
          <Route exact path="/login" component={SignIn}/>
          <Route exact path="/register" component={Register}/>
          <Route exact path="/recovery" component={ForgotPassword}/>
          <Route exact path="/logout" render = {() => {
              session.clear().then(()=>{
                window.location.href = "/login"
              });
          }} />
          {/* The Deck Builder is its own tier-4 capability (below Jam Builder) */}
          <TierRoute exact path="/deckbuilder" capability="access_deckbuilder" component={DeckBuilder}/>
          <Route exact path="/pro" render={(props) => <PasswordGate><Home {...props}/></PasswordGate>} />
          <Route exact path="/dashboard" component={Dashboard}/>
          <Route exact path="/frontpage" component={frontPage}/>
          {/* Terms of Use page. Must stay ABOVE the /:open catch-all (which otherwise
              renders the Dashboard for any single-segment path). */}
          <Route exact path="/terms" component={TermsOfUse}/>

          {/* <Route exact path="/event/page" component={EventPage}/> */}
          <Route exact path="/event/settings" component={EventSetting}/>
          {/* <Route exact path="/event/workshop" component={DndPage}/> */}
          <Route exact path="/event/page/:pageId" component={EventPage2}/>


          <Route path="/:open" component={Dashboard} />
          <Route path="*" render={(props)=><Error {...props} message={"Page Not Found."}/>}/>

        </Switch>
      </UserAccessProvider>
    </Router>
  )

  // return(
  //   <>
  //         <Route exact path="/test/state" component={State}/>
  //         <Route exact path="/test/playground" component={Playground} />
  //         <Route exact path="/test/canvas" component={TestCanvas} />
  //         <Route exact path="/test/chat" component={Chat}/>
  //         <Route exact path="/test/smiley" component={Smiley}/>
  //         <Route exact path="/game" component={PreGame}/>
  //         <Route exact path="/test/jambuilder" component={JamBuilder}/>

  //         <Route exact path="/topic" component={Topic}/>
  //         <Route exact path="/:id/jamsetup" component={Prejam}/>
  //         <Route exact path="/:id/jam/:sid" component={Jam}/>
  //         <Route exact path="/project" component={ProjectList}/>
  //         <Route exact path="/jam" component={JamList}/>
  //         <Route exact path="/:id/project/:pid" component={Project}/>
  //         <Route exact path="/profile" component={Profile}/>
  //   </>
  // )
}

export default Routing;